import { Portal as ChakraPortal } from '@chakra-ui/react';
import { forwardRef } from 'react';
export const Portal = forwardRef(({ children, ...props }, ref) => {
  return (
    <ChakraPortal ref={ref} {...props}>
      {children}
    </ChakraPortal>
  );
});
